import { EmailAddressStatus, EmailSesVerificationStatus } from '@models';

export const mapEmailSesVerificationToViewString = {
  [EmailSesVerificationStatus.Success]: EmailAddressStatus.Confirmed,
  [EmailSesVerificationStatus.Pending]: EmailAddressStatus.Pending,
  [EmailSesVerificationStatus.Failed]: EmailAddressStatus.Pending,
  [EmailSesVerificationStatus.NotStarted]: EmailAddressStatus.Pending,
  [EmailSesVerificationStatus.TemporaryFailure]: EmailAddressStatus.Pending,
};
